export const ACCEPTED_TYPES: Record<string, string[]> = {
  'text/plain': ['.txt'],
  'application/json': ['.json'],
  'text/xml': ['.xml'],
  'text/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc', '.dot'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': ['.dotx'],
  'application/vnd.ms-word.document.macroEnabled.12': ['.docm'],
  'application/vnd.ms-word.template.macroEnabled.12': ['.dotm'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/rtf': ['.rtf'],
  'application/vnd.ms-excel': ['.xls', '.xlt'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': ['.xltx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'application/vnd.ms-excel.template.macroEnabled.12': ['.xltm'],
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ['.xlsb'],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
}

// The uploader rejects these types; an unknown one (e.g. .xlsb without Office installed) is empty here
// and goes out as application/octet-stream. Name the type from the extension instead.
const UPLOADER_BLOCKED = new Set(['', 'application/octet-stream', 'application/xml'])

export const withMimeType = (file: File): File => {
  if (!UPLOADER_BLOCKED.has(file.type)) return file
  const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
  const type = Object.keys(ACCEPTED_TYPES).find((mime) => ACCEPTED_TYPES[mime].includes(ext))
  return type ? new File([file], file.name, { type, lastModified: file.lastModified }) : file
}
